import { getUuid } from "@common/utils/uuid";
import { FILE_CHUNK_SIZE } from "@common/model/data";
import {
  GlobalUploadResData,
  GlobalDownResData
} from "@common/model/interface";
import {
  getImgPathApi,
  previewFileApi,
  uploadFileApi,
  downFileApi
} from "@common/api/upload";
import { ResourceService } from "@common/service/base-service/resource";

export class GlobalOnlyUploadService {
  static request;
  static isStop = false;

  static setRequest(request) {
    this.request = request;
  }
  // 图片资源获取能显示的地址
  static showImg(url: string): Promise<string> {
    return previewFileApi(this.request, url);
  }
  // 图片资源获取能显示的地址 -- 数组
  static getImgPath(data) {
    return getImgPathApi(this.request, data);
  }
  static judgeShowImg(url: string): Promise<string> {
    if (url.indexOf("http") > -1 || url.indexOf(".com") > -1) {
      return new Promise(resolve => {
        resolve(url);
      });
    } else {
      return previewFileApi(this.request, url);
    }
  }
  static showVideo(url: string): Promise<string> {
    return previewFileApi(this.request, url);
  }
  static upload(
    file: any,
    fileCategory?: string,
    onProgress?: Function,
    ApiFuniton?: Function
  ): Promise<GlobalUploadResData> {
    this.isStop = false;
    return new Promise((resolve, reject) => {
      const fileMd5Code = getUuid(10);
      const callBack = fileMd5Code => {
        const fileName = ResourceService.getFileName(file);
        const totalChunkSize = ResourceService.getTotalChunkSize(file);

        // const isVideo = ResourceService.isVideo(file);
        (async () => {
          for (
            let currentChunk = 0;
            currentChunk < totalChunkSize;
            currentChunk++
          ) {
            if (this.isStop) {
              break;
            }
            // 准备
            const start = currentChunk * FILE_CHUNK_SIZE;
            const end = start + FILE_CHUNK_SIZE;
            const multipartFile = file.slice(start, end);
            const formData = ResourceService.getFileFormData({
              fileName,
              fileMd5Code,
              totalChunkSize,
              currentChunk,
              multipartFile
              // videoTime
            });
            try {
              if (fileCategory) {
                formData.append("fileCategory", fileCategory);
              }
              if (file.fileCategory) {
                formData.append("fileCategory", file.fileCategory);
              }

              const api = ApiFuniton || uploadFileApi;
              const res = await api(this.request, formData);
              // 进度
              const progress = Math.floor(
                (100 * (currentChunk + 1)) /
                  ResourceService.getTotalChunkSize(file)
              );
              onProgress && onProgress(progress);
              // 上传成功
              if (progress == 100) {
                resolve(res);
              }
            } catch (e) {
              reject(e);
            }
          }
        })();
      };
      callBack(fileMd5Code);
    });
  }
  static download(id: string | number): Promise<GlobalDownResData> {
    return new Promise((resolve, reject) => {
      (async () => {
        try {
          const res = await downFileApi(this.request, id);
          resolve(res);
        } catch (e) {
          reject(e);
        }
      })();
    });
  }
}
